import React from 'react';
import styled from 'styled-components';
import { ClipLoader } from 'react-spinners';

import { Flex } from './Layout';
import ThemeStyle from '../../../lib/style/ThemeStyle';

export function Button({
  isLoading = false,
  color = ThemeStyle.color,
  children,
  size,
  ...props
}) {
  return (
    <ButtonWrapper color={color} size={size} {...props}>
      {isLoading ? (
        <ClipLoader
          color={
            ThemeStyle.color[color === 'background' ? 'darekest' : 'background']
          }
          size={size === 'small' ? 16 : 24}
        />
      ) : (
        children
      )}
    </ButtonWrapper>
  );
}

Button.defaultProps = {
  size: 'large',
  color: ThemeStyle.color.orangePink,
};

const ButtonWrapper = styled(Flex)`
  padding: ${(props) => (props.size === 'small' ? '0.125rem 0' : '0.688rem 0')};
  width: 100%;
  border-radius: 6px;
  background: ${(props) =>
    props.theme.color[props.color] || props.theme.color.orangePink};
  color: ${(props) =>
    props.color === 'background'
      ? props.theme.color.darkest
      : props.theme.color.background};
  &,
  span {
    font-weight: ${(props) =>
      props.theme.typography.weight[
        props.size === 'small' ? 'regular' : 'bold'
      ]};
    color: ${(props) =>
      props.color === 'background'
        ? props.theme.color.darkest
        : props.theme.color.background};
  }
  cursor: pointer;
`;
